<template>
  <div>
    <div style="text-align:left;color:#333;width:1200px;padding:0 90px;">个人中心</div>
    <div class="tit">企业信息</div>
    <el-form
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      style="padding:0 170px 30px 170px"
      :rules="rules"
      :model="ruleForm"
    >
      <el-form-item
        label="企业名称："
        class="cell"
      >
        <el-input
          v-model="ruleForm.enterpriseName"
          style="width:288px;"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item
        class="cell"
        label="地址："
        prop="address"
      >
        <el-input
          v-model="ruleForm.address"
          style="width:288px;"
          placeholder='请输入地址'
        ></el-input>
      </el-form-item>
      <el-form-item
        class="cell"
        label="联系方式："
        prop="contactNumber"
      >
        <el-input
          v-model="ruleForm.contactNumber"
          style="width:288px;"
          placeholder='请输入联系方式'
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="btLoading"
        >保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { user } from "@/api/ajax";
import { btLoading } from "@/Mixin/btLoading";
import { dbCon } from '@/Mixin/doubleConfirm'
export default {
  mixins: [btLoading, dbCon],
  data () {
    return {

      ruleForm: {},
      rules: {
        contactNumber: [
          {
            required: true,
            message: "联系电话不能为空",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "地址不能为空",
            trigger: "blur"
          }
        ],
      }
    }
  },
  methods: {
    submitForm (formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let cbEvent = () => {
            user
              .updateEnterprise(
                {
                  id: this.ruleForm.id,
                  contactNumber: this.ruleForm.contactNumber,
                  address: this.ruleForm.address
                }
              )
              .then(res => {
                this.$notify({
                  title: "成功",
                  message: "提交成功",
                  type: "success"
                });
                this.$router.push({ name: 'home' })
              });
          };
          cbEvent();
        } else {
          return false;
        }
      });
    }
  },
  created () {
    user.userCenter().then(res => {
      this.ruleForm = res.data.data
      // console.log(res.data)
    })


  }
}
</script>
<style lang="scss" scoped>
.tit {
  text-align: left;
  width: 1280px;
  padding: 0 90px;
  // margin: 0 auto;
  margin-top: 45px;
  color: #2e2f2f;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  line-height: 24px;
  margin-bottom: 30px;
}
.tit::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  display: block;
  margin-right: 8px;
}
.cell {
  width: 320px;
}
</style>


